/** UI color palette keyed 1-4. Resolve keys via utils/locationColor (legacy selectedRoom or ROOM_LIST locationId). */
export const ROOM_COLOR_MAPPING: Record<number, { color: string; className: string }> = {
  1: { color: "#91eeff", className: "room-1-available-background" },
  2: { color: "#a0fdb0", className: "room-2-available-background" },
  3: { color: "#fbbbb0", className: "room-3-available-background" },
  4: { color: "#d6b2ed", className: "room-4-available-background" },
};
